import { useContext } from "react";
import { AvisContext } from "../../context/AvisContext";
import classNames from "classnames";

interface IAvisDescriptiveTextProps {
  className?: string;
  textKey: string;
}
export function AvisDescriptiveText(
  props: Readonly<IAvisDescriptiveTextProps>,
) {
  const { getText } = useContext(AvisContext);
  const { textKey, className } = props;
  const textContentClassName = classNames(className, "avis-descriptive-text");

  const textValue = getText(textKey);

  if (!textValue) return;

  return <div className={textContentClassName}>{textValue}</div>;
}
